import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const initialState = {
  livingThingsData: [],
  livingThingsLoader: true,
  livingThingsError: "",
};

const getEndpoint = (roomName) => {
  const loc = localStorage.getItem('userLocation');
   const prefix = loc === 'kkt' ? 'kkt' : '';
  // const prefix = localStorage.getItem('userLocation');
  const db = localStorage.getItem('projectDatabase') || '(default)'; // fallback for safety
  // return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}`;
  return `https://us-central1-fabdiz-quote.cloudfunctions.net/api/rooms/${prefix}${roomName}/${db}`;
};

export const fetchLivingThingsList = createAsyncThunk(
  'fetchlivingThings',
  async ({  } = {}, { rejectWithValue }) => {
    try {
      const url = getEndpoint('LivingRoom');
      const response = await fetch(url);
      if (!response.ok) throw new Error('Failed to fetch living room data');
      return await response.json();
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const LivingRoomReducer = createSlice({
  name: 'livingThings',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchLivingThingsList.fulfilled]: (state, action) => {
      state.livingThingsData = action.payload;
      state.livingThingsLoader = false;
      state.livingThingsError = "";
    },
    [fetchLivingThingsList.pending]: (state) => {
      state.livingThingsLoader = true;
      state.livingThingsError = "";
    },
    [fetchLivingThingsList.rejected]: (state, action) => {
      state.livingThingsLoader = false;
      state.livingThingsError = action.payload ?? "refresh the page";
    },
  },
});

export default LivingRoomReducer.reducer;